import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })

export class ShadowService {
  select() {
    const ionSelects = document.querySelectorAll('ion-select');
    ionSelects.forEach(ionSelect => {
      ionSelect.shadowRoot.querySelector('.select-icon')
      .setAttribute('style', 'display: none');
      ionSelect.shadowRoot.querySelector('.select-placeholder')
      .setAttribute('style', 'opacity: 0.9');
    });
  }

  button() {
    const ionButtons = document.querySelectorAll('ion-button');
    ionButtons.forEach(ionButton => {
      ionButton.shadowRoot.querySelector('.button-native')
      .setAttribute('style', 'box-shadow: none !important');
    });
  }

  transparentButton() {
    const buttonTrans = document.querySelector('ion-button.btn-trans');
    buttonTrans.shadowRoot.querySelector('.button-native')
    .setAttribute('style', 'background: #fff !important');
  }

  actionSheet() {
    const actionSheet = document.querySelector('ion-action-sheet');
    actionSheet.setAttribute('tabindex', '0');
  }
}
